import { useJsApiLoader } from "@react-google-maps/api";

const LIBRARIES = ["drawing", "places", "geometry", "visualization"];

const PublicGoogleMapLoader = ({ googleKey, children }) => {
  console.log("🧩 PublicGoogleMapLoader rendered", googleKey);
  
  // Always call the hook first
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-public",
    googleMapsApiKey: googleKey || "",
    libraries: LIBRARIES,
  });

  // Check if googleKey is available
  if (!googleKey) {
    return <div>Preparing secure map…</div>;
  }

  if (loadError) {
    console.error("Google Maps load error:", loadError);
    return <div>Failed to load map</div>;
  }

  if (!isLoaded) {
    return <div>Loading map…</div>;
  }

  // Double-check that google.maps is available
  if (!window.google?.maps) {
    return <div>Initializing maps…</div>;
  }

  return typeof children === "function"
    ? children({ isLoaded: true })
    : children;
};

export default PublicGoogleMapLoader;
